import { render, staticRenderFns } from "./moduleItem.vue?vue&type=template&id=20a0fb4c&functional=true&"
import script from "./moduleItem.vue?vue&type=script&lang=ts&"
export * from "./moduleItem.vue?vue&type=script&lang=ts&"
import style0 from "./moduleItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports